import React from 'react';

const SmdIcon = ({icon, onClick, cssClass}) => {
    return (
        <span onClick={onClick} className={`svg-icon ${cssClass||''}`}>
            <i className={`smdicon-${icon}`}></i>
        </span>
    )
}

export default SmdIcon;